export default {"src":"/_next/static/media/cor2.bfbe3e53.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};